import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ApiService } from '../core/services/api.service';
import { Meta, Title } from '@angular/platform-browser';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Apiconfig } from '../core/helpers/apiConfig';
import { SafeHtmlPipe } from '../core/pipes/safe-html.pipe';

@Component({
  selector: 'app-site-page',
  standalone: true,
  imports: [CommonModule, RouterModule, SafeHtmlPipe],
  templateUrl: './site-page.component.html',
  styleUrl: './site-page.component.scss'
})
export class SitePageComponent implements OnInit {
  page: any;
  pageDescription: any;
  heading: string = ''
  slug: any


  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private titleService: Title,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private metaService: Meta, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.apiService.commonApi(Apiconfig.landingData.method, Apiconfig.landingData.url, {}).subscribe((result: any) => {
      if (result && Array.isArray(result.response)) {
        var settigns = result.response.filter((e: any) => Object.keys(e).includes('Settings'))
        if (settigns && settigns.length > 0) {
          var general = settigns[0].Settings && settigns[0].Settings.settings;
          this.apiService.setAppFavicon(general.favicon);
          // this.titleService.setTitle(general.site_title);
          // this.meta.updateTag({ name: 'og:title', content: general.site_title });
        }
      }
    });

    this.activatedRoute.params.subscribe(params => {
      const id = params['slug'];
      this.page = id;
      console.log(id, 'this is the slug from the page..')
      this.apiService.commonApi(Apiconfig.Getpage.method, Apiconfig.Getpage.url, { slug: id }).subscribe(
        (result: any) => {
          console.log("result")
          if (result && result.status) {
            console.log(result.data, "result.dataresult.dataresult.dataresult.dataresult.data");
            this.slug = result.data.slug
            this.pageDescription = result.data ? (result.data.description ? result.data.description : '') : '';
            this.heading = result.data.name
          }
        },
        (error) => {
          console.log(error);
        }
      );
    })

  }

  ngOnInit(): void {
    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/page/blogs",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);


    this.titleService.setTitle('Fertility & IVF Blogs | Latest Insights from NCARE IVF Centre in Kannur');
    this.metaService.updateTag({
      name: 'description',
      content: 'Stay informed with expert-written blogs from NCARE IVFCentre in  Kannur. Explore topics on fertility, IVF, pregnancy care, and reproductive health for reliable, up-to-date guidance.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'Fertility Blogs, IVF Blog Kannur, Reproductive Health Articles, Pregnancy Care Tips, NCARE IVF Updates'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Fertility & IVF Blogs | Latest Insights from NCARE IVF Centre in Kannur'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Stay informed with expert-written blogs from NCARE IVFCentre in  Kannur. Explore topics on fertility, IVF, pregnancy care, and reproductive health for reliable, up-to-date guidance.'
    });
  }

}
